// KEY FIX: getProductGroup — was calling /group/comman/ (typo kept to match your router)
// KEY FIX: updateProductVariant + updateProductGroupCommon — removed manual Content-Type header
//          (setting it manually breaks multipart boundary and multer gets no files)

import axios from "axios";
import {
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_CREATE_REQUEST,
  PRODUCT_CREATE_FAIL,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_BULK_UPLOAD_REQUEST,
  PRODUCT_BULK_UPLOAD_SUCCESS,
  PRODUCT_BULK_UPLOAD_FAIL,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_FAIL,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_CREATE_REVIEW_REQUEST,
  PRODUCT_CREATE_REVIEW_SUCCESS,
  PRODUCT_CREATE_REVIEW_FAIL,
  REVIEW_LIST_REQUEST,
  REVIEW_LIST_SUCCESS,
  REVIEW_LIST_FAIL,
  REVIEW_APPROVE_REQUEST,
  REVIEW_APPROVE_SUCCESS,
  REVIEW_APPROVE_FAIL,
  REVIEW_DELETE_REQUEST,
  REVIEW_DELETE_SUCCESS,
  REVIEW_DELETE_FAIL,
  PRODUCT_VARIANTS_REQUEST,
  PRODUCT_VARIANTS_SUCCESS,
  PRODUCT_VARIANTS_FAIL,
  PRODUCT_GROUP_DETAILS_REQUEST,
  PRODUCT_GROUP_DETAILS_SUCCESS,
  PRODUCT_GROUP_DETAILS_FAIL,
  PRODUCT_GROUP_UPDATE_REQUEST,
  PRODUCT_GROUP_UPDATE_SUCCESS,
  PRODUCT_GROUP_UPDATE_FAIL,
  PRODUCT_VARIANT_ADD_REQUEST,
  PRODUCT_VARIANT_ADD_SUCCESS,
  PRODUCT_VARIANT_ADD_FAIL,
  PRODUCT_EDIT_REQUEST,
  PRODUCT_EDIT_SUCCESS,
  PRODUCT_EDIT_FAIL,
  PRODUCT_LIST_BY_GROUP_REQUEST,
  PRODUCT_LIST_BY_GROUP_SUCCESS,
  PRODUCT_LIST_BY_GROUP_FAIL,
  PRODUCT_GROUP_REQUEST,
  PRODUCT_GROUP_SUCCESS,
  PRODUCT_GROUP_FAIL,
  PRODUCT_VARIANT_UPDATE_REQUEST,
  PRODUCT_VARIANT_UPDATE_SUCCESS,
  PRODUCT_VARIANT_UPDATE_FAIL,
  PRODUCT_HAS_COMBO_REQUEST,
  PRODUCT_HAS_COMBO_SUCCESS,
  PRODUCT_HAS_COMBO_FAIL,
  REVIEW_UNAPPROVE_REQUEST,
  REVIEW_UNAPPROVE_SUCCESS,
  REVIEW_UNAPPROVE_FAIL,
} from "../constants/productConstants";

const API_URL = process.env.REACT_APP_API_URL;

export const listProducts =
  (keyword = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_LIST_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: userInfo?.token
          ? { Authorization: `Bearer ${userInfo.token}` }
          : {},
      };
      const { data } = await axios.get(
        `${API_URL}/api/products?keyword=${keyword}`,
        config,
      );
      dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_LIST_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const Listproductbyfiters = (filters) => async (dispatch, getState) => {
  dispatch({ type: PRODUCT_LIST_REQUEST });
  const {
    userLogin: { userInfo },
  } = getState();
  const config = {
    headers: userInfo?.token
      ? { Authorization: `Bearer ${userInfo.token}` }
      : {},
  };
  let queryString = "?";
  for (let key in filters) {
    if (filters[key]) queryString += `&${key}=${filters[key]}`;
  }
  const { data } = await axios.get(
    `${API_URL}/api/products/${queryString}`,
    config,
  );
  dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data });
};

export const listProductVariants = (sku) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_VARIANTS_REQUEST });
    const { data } = await axios.get(`${API_URL}/api/products/variants/${sku}`);
    dispatch({ type: PRODUCT_VARIANTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_VARIANTS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const listProductDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: userInfo?.token
        ? { Authorization: `Bearer ${userInfo.token}` }
        : {},
    };
    const { data } = await axios.get(`${API_URL}/api/products/${id}`, config);
    dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const DeleteProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    await axios.delete(`${API_URL}/api/products/${id}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: PRODUCT_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: PRODUCT_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const CreateProduct = (productData) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_CREATE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.post(
      `${API_URL}/api/products/create`,
      productData,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: PRODUCT_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getProductBySkuDetails = (sku) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });
    const { data } = await axios.get(`${API_URL}/api/products/sku/${sku}`);
    dispatch({ type: PRODUCT_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const uploadBulkProducts = (file) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_BULK_UPLOAD_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await axios.post(
      `${API_URL}/api/products/upload`,
      formData,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: PRODUCT_BULK_UPLOAD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_BULK_UPLOAD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const UpdateProduct =
  (productId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.put(
        `${API_URL}/api/products/${productId}`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: PRODUCT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const createproductReview =
  (productId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_CREATE_REVIEW_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.post(
        `${API_URL}/api/products/${productId}/reviews`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: PRODUCT_CREATE_REVIEW_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_CREATE_REVIEW_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const listPendingReviews = () => async (dispatch, getState) => {
  try {
    dispatch({ type: REVIEW_LIST_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.get(
      `${API_URL}/api/products/reviews/pending`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: REVIEW_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: REVIEW_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const approveReview =
  (productId, reviewId) => async (dispatch, getState) => {
    try {
      dispatch({ type: REVIEW_APPROVE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.put(
        `${API_URL}/api/products/${productId}/reviews/${reviewId}/approve`,
        {},
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: REVIEW_APPROVE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: REVIEW_APPROVE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const deleteReview = (reviewId) => async (dispatch, getState) => {
  try {
    dispatch({ type: REVIEW_DELETE_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.delete(
      `${API_URL}/api/products/reviews/${reviewId}`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: REVIEW_DELETE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: REVIEW_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getProductsByGroupId = (groupId) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_GROUP_DETAILS_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.get(
      `${API_URL}/api/products/group/${groupId}`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: PRODUCT_GROUP_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_GROUP_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const updateGroupCommonFields =
  (groupId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_GROUP_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      // ✅ No manual Content-Type — axios sets multipart/form-data boundary automatically
      const { data } = await axios.put(
        `${API_URL}/api/products/group/${groupId}/common`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: PRODUCT_GROUP_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_GROUP_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// ✅ CRITICAL FIX: Do NOT set Content-Type manually for FormData
// If you set "Content-Type: multipart/form-data" manually, the multipart boundary is missing
// and multer receives no files. Let axios set it automatically.
export const updateProductVariant =
  (variantId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_VARIANT_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.put(
        `${API_URL}/api/products/group/variant/${variantId}`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } }, // ✅ NO Content-Type here
      );
      dispatch({ type: PRODUCT_VARIANT_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_VARIANT_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const addVariantToGroup =
  (groupId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_VARIANT_ADD_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.post(
        `${API_URL}/api/products/group/${groupId}/variant`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: PRODUCT_VARIANT_ADD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_VARIANT_ADD_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const getProductFull = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_EDIT_REQUEST });
    const { data } = await axios.get(`${API_URL}/api/products/${id}/full`);
    dispatch({ type: PRODUCT_EDIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_EDIT_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const updateProductGroup =
  (groupId, updatedData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_GROUP_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.put(
        `${API_URL}/api/products/group/${groupId}`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        },
      );
      dispatch({ type: PRODUCT_GROUP_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_GROUP_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const markReviewHelpful =
  (productId, reviewId) => async (dispatch, getState) => {
    const {
      userLogin: { userInfo },
    } = getState();
    await axios.put(
      `${API_URL}/api/products/${productId}/reviews/${reviewId}/helpful`,
      {},
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch(listProductDetails(productId));
  };

export const markReviewNotHelpful =
  (productId, reviewId) => async (dispatch, getState) => {
    const {
      userLogin: { userInfo },
    } = getState();
    await axios.put(
      `${API_URL}/api/products/${productId}/reviews/${reviewId}/not-helpful`,
      {},
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch(listProductDetails(productId));
  };

export const listProductsByGroupId =
  (groupId) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_LIST_BY_GROUP_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: userInfo?.token
          ? { Authorization: `Bearer ${userInfo.token}` }
          : {},
      };
      const { data } = await axios.get(
        `${API_URL}/api/products/group/${groupId}`,
        config,
      );
      dispatch({ type: PRODUCT_LIST_BY_GROUP_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: PRODUCT_LIST_BY_GROUP_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

// ✅ URL kept as "comman" to match your existing router (don't change unless you update the router too)
export const getProductGroup = (groupId) => async (dispatch, getState) => {
  try {
    dispatch({ type: PRODUCT_GROUP_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.get(
      `${API_URL}/api/products/group/comman/${groupId}`,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: PRODUCT_GROUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: PRODUCT_GROUP_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// ✅ No manual Content-Type for FormData
export const updateProductGroupCommon =
  (groupId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCT_GROUP_UPDATE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      await axios.put(
        `${API_URL}/api/products/group/${groupId}/common`,
        formData,
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: PRODUCT_GROUP_UPDATE_SUCCESS });
    } catch (error) {
      dispatch({
        type: PRODUCT_GROUP_UPDATE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const checkHasCombo = () => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_HAS_COMBO_REQUEST });
    const { data } = await axios.get(`${API_URL}/api/products/has-combo`);
    dispatch({ type: PRODUCT_HAS_COMBO_SUCCESS, payload: data.hasCombo });
  } catch (error) {
    dispatch({ type: PRODUCT_HAS_COMBO_FAIL, payload: error.message });
  }
};

export const unapproveReview =
  (productId, reviewId) => async (dispatch, getState) => {
    try {
      dispatch({ type: REVIEW_UNAPPROVE_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const { data } = await axios.put(
        `${API_URL}/api/products/${productId}/reviews/${reviewId}/unapprove`,
        {},
        { headers: { Authorization: `Bearer ${userInfo.token}` } },
      );
      dispatch({ type: REVIEW_UNAPPROVE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: REVIEW_UNAPPROVE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };

export const listAllReviews = () => async (dispatch, getState) => {
  try {
    dispatch({ type: REVIEW_LIST_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const { data } = await axios.get(`${API_URL}/api/products/reviews/all`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({
      type: REVIEW_LIST_SUCCESS,
      payload: Array.isArray(data) ? data : [],
    });
  } catch (error) {
    dispatch({
      type: REVIEW_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
